// extracted by mini-css-extract-plugin
export var equalColumn = "_em-0";